/**
 * Platform brand — user-facing name for the overall service (FusionMSI).
 * Product tiles (MasterChart, CareStart, DecisionPoint, …) keep their own names.
 *
 * Do not confuse with internal package aliases (@healthdesk/*), Firebase project
 * ids (caremap2020 / hlthdsk-*), or clinical "bedside" language.
 *
 * Host-specific chrome (top bar, auth, favicon) should call `getPlatformBranding()`.
 * The static exports below stay FusionMSI so DecisionPoint / chatbot call sites
 * are not silently retitled on appliedsuperintelligence.com.
 */

import { isAsiMarketingHost } from "features/asi/marketing/asiMarketingRouting";

export const PLATFORM_NAME = "FusionMSI";
export const PLATFORM_NAME_LONG = "Fusion Medical SuperIntelligence";
/** Chat / assistant sender label in the main app. */
export const PLATFORM_ASSISTANT_NAME = "FusionMSI";
/** Legacy constant name kept for call-site clarity during migration. */
export const HEALTH_DESK_SENDER = PLATFORM_ASSISTANT_NAME;

const FUSION_MSI_BRANDING = Object.freeze({
  name: PLATFORM_NAME,
  nameLong: PLATFORM_NAME_LONG,
  assistantName: PLATFORM_ASSISTANT_NAME,
});

const ASI_BRANDING = Object.freeze({
  name: "Applied SuperIntelligence",
  nameLong: "Applied SuperIntelligence",
  assistantName: "ASI",
});

/**
 * Host-aware platform chrome names. FusionMSI everywhere except the ASI
 * dedicated host (or ASI_MARKETING_HOST=1 preview).
 */
export function getPlatformBranding() {
  return isAsiMarketingHost() ? ASI_BRANDING : FUSION_MSI_BRANDING;
}
